// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/content/v2/content.v2.proto (package no.jotta.openapi.content.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { DownloadLocationRequest, DownloadLocationResponse, DownloadLocationsRequest, DownloadLocationsResponse, PrepareDownloadRequest } from "./content.v2_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.content.v2.ContentLocatorService.DownloadLocation
 */
export const downloadLocation = {
    localName: "downloadLocation",
    name: "DownloadLocation",
    kind: MethodKind.Unary,
    I: DownloadLocationRequest,
    O: DownloadLocationResponse,
    service: {
        typeName: "no.jotta.openapi.content.v2.ContentLocatorService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.content.v2.ContentLocatorService.DownloadLocations
 */
export const downloadLocations = {
    localName: "downloadLocations",
    name: "DownloadLocations",
    kind: MethodKind.Unary,
    I: DownloadLocationsRequest,
    O: DownloadLocationsResponse,
    service: {
        typeName: "no.jotta.openapi.content.v2.ContentLocatorService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.content.v2.ContentLocatorService.PrepareDownload
 */
export const prepareDownload = {
    localName: "prepareDownload",
    name: "PrepareDownload",
    kind: MethodKind.Unary,
    I: PrepareDownloadRequest,
    O: DownloadLocationResponse,
    service: {
        typeName: "no.jotta.openapi.content.v2.ContentLocatorService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.content.v2.ContentLocatorService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.content.v2.ContentLocatorService"
    }
};
